// DO NOT EDIT THIS FILE!!!
// Update it by running `rake javascript:update_constants`

export const HOLIDAY_REGIONS = [
  "ae",
  "ar",
  "at",
  "au",
  "au_nsw",
  "au_vic",
  "au_qld",
  "au_nt",
  "au_act",
  "au_sa",
  "au_wa",
  "au_tas",
  "au_tas_south",
  "au_qld_cairns",
  "au_qld_brisbane",
  "au_tas_north",
  "au_vic_melbourne",
  "be_fr",
  "be_nl",
  "br",
  "br_spcapital",
  "br_sp",
  "bg_en",
  "bg_bg",
  "ca",
  "ca_qc",
  "ca_ab",
  "ca_sk",
  "ca_on",
  "ca_bc",
  "ca_nb",
  "ca_mb",
  "ca_ns",
  "ca_pe",
  "ca_nl",
  "ca_nt",
  "ca_nu",
  "ca_yt",
  "us",
  "ch_zh",
  "ch_be",
  "ch_lu",
  "ch_ur",
  "ch_sz",
  "ch_ow",
  "ch_nw",
  "ch_gl",
  "ch_zg",
  "ch_fr",
  "ch_so",
  "ch_bs",
  "ch_bl",
  "ch_sh",
  "ch_ar",
  "ch_ai",
  "ch_sg",
  "ch_gr",
  "ch_ag",
  "ch_tg",
  "ch_ti",
  "ch_vd",
  "ch_ne",
  "ch_ge",
  "ch_ju",
  "ch_vs",
  "ch",
  "cl",
  "co",
  "cr",
  "cz",
  "dk",
  "de",
  "de_bw",
  "de_by",
  "de_he",
  "de_nw",
  "de_rp",
  "de_sl",
  "de_sn_sorbian",
  "de_th_cath",
  "de_sn",
  "de_st",
  "de_be",
  "de_by_cath",
  "de_by_augsburg",
  "de_th",
  "de_bb",
  "de_mv",
  "de_hb",
  "de_hh",
  "de_ni",
  "de_sh",
  "ee",
  "gr",
  "es_pv",
  "es_na",
  "es_an",
  "es_ib",
  "es_cm",
  "es_mu",
  "es_m",
  "es_ar",
  "es_cl",
  "es_cn",
  "es_lo",
  "es_ga",
  "es_ce",
  "es_o",
  "es_ex",
  "es",
  "es_ct",
  "es_v",
  "es_vc",
  "fi",
  "fr_a",
  "fr_m",
  "fr",
  "gb",
  "gb_eng",
  "gb_wls",
  "gb_eaw",
  "gb_nir",
  "je",
  "gb_jsy",
  "gg",
  "gb_gsy",
  "gb_sct",
  "gb_con",
  "im",
  "gb_iom",
  "ge",
  "gh",
  "hr",
  "hk",
  "hu",
  "id",
  "ie",
  "in",
  "in_mh",
  "in_gj",
  "in_ka",
  "in_tn",
  "is",
  "it",
  "it_ve",
  "it_tv",
  "it_vr",
  "it_pd",
  "it_fi",
  "it_ge",
  "it_to",
  "it_rm",
  "it_vi",
  "it_bl",
  "it_ro",
  "kr",
  "kz",
  "li",
  "lt",
  "lv",
  "ma",
  "mt_mt",
  "mt_en",
  "mx",
  "mx_pue",
  "nl",
  "lu",
  "no",
  "nz",
  "nz_sl",
  "nz_we",
  "nz_ak",
  "nz_nl",
  "nz_ne",
  "nz_ot",
  "nz_ta",
  "nz_sc",
  "nz_hb",
  "nz_mb",
  "nz_ca",
  "nz_ch",
  "nz_wl",
  "pe",
  "ph",
  "pl",
  "pt",
  "pt_li",
  "pt_po",
  "ro",
  "rs_cyrl",
  "rs_la",
  "ru",
  "se",
  "sa",
  "tn",
  "tr",
  "ua",
  "us_la",
  "us_ct",
  "us_de",
  "us_ga",
  "us_hi",
  "us_in",
  "us_ky",
  "us_nj",
  "us_nc",
  "us_nd",
  "us_pr",
  "us_tn",
  "us_il",
  "us_vt",
  "us_ak",
  "us_ca",
  "us_dc",
  "us_me",
  "us_ma",
  "us_al",
  "us_ms",
  "us_ne",
  "us_mo",
  "us_sc",
  "us_wv",
  "us_ut",
  "us_ri",
  "us_nv",
  "us_ny",
  "us_nm",
  "us_md",
  "us_fl",
  "us_ia",
  "us_ks",
  "us_mi",
  "us_mn",
  "us_nh",
  "us_ok",
  "us_or",
  "us_pa",
  "us_tx",
  "us_va",
  "us_wa",
  "us_ar",
  "us_wi",
  "za",
  "ve",
  "sk",
  "si",
  "jp",
  "vi",
  "sg",
  "my",
  "th",
  "ng",
  "ke",
  "zw",
];

export const TIME_ZONE_TO_REGION = {
  "Africa/Accra": "gh",
  "Africa/Casablanca": "ma",
  "Africa/Ceuta": "es",
  "Africa/Harare": "zw",
  "Africa/Johannesburg": "za",
  "Africa/Lagos": "ng",
  "Africa/Nairobi": "ke",
  "Africa/Tunis": "tn",
  "America/Adak": "us",
  "America/Anchorage": "us",
  "America/Araguaina": "br",
  "America/Argentina/Buenos_Aires": "ar",
  "America/Argentina/Catamarca": "ar",
  "America/Argentina/Cordoba": "ar",
  "America/Argentina/Jujuy": "ar",
  "America/Argentina/La_Rioja": "ar",
  "America/Argentina/Mendoza": "ar",
  "America/Argentina/Rio_Gallegos": "ar",
  "America/Argentina/Salta": "ar",
  "America/Argentina/San_Juan": "ar",
  "America/Argentina/San_Luis": "ar",
  "America/Argentina/Tucuman": "ar",
  "America/Argentina/Ushuaia": "ar",
  "America/Atikokan": "ca",
  "America/Bahia": "br",
  "America/Bahia_Banderas": "mx",
  "America/Belem": "br",
  "America/Blanc-Sablon": "ca",
  "America/Boa_Vista": "br",
  "America/Bogota": "co",
  "America/Boise": "us",
  "America/Cambridge_Bay": "ca",
  "America/Campo_Grande": "br",
  "America/Cancun": "mx",
  "America/Caracas": "ve",
  "America/Chicago": "us",
  "America/Chihuahua": "mx",
  "America/Ciudad_Juarez": "mx",
  "America/Costa_Rica": "cr",
  "America/Coyhaique": "cl",
  "America/Creston": "ca",
  "America/Cuiaba": "br",
  "America/Dawson": "ca",
  "America/Dawson_Creek": "ca",
  "America/Denver": "us",
  "America/Detroit": "us",
  "America/Edmonton": "ca",
  "America/Eirunepe": "br",
  "America/Fort_Nelson": "ca",
  "America/Fortaleza": "br",
  "America/Glace_Bay": "ca",
  "America/Goose_Bay": "ca",
  "America/Halifax": "ca",
  "America/Hermosillo": "mx",
  "America/Indiana/Indianapolis": "us",
  "America/Indiana/Knox": "us",
  "America/Indiana/Marengo": "us",
  "America/Indiana/Petersburg": "us",
  "America/Indiana/Tell_City": "us",
  "America/Indiana/Vevay": "us",
  "America/Indiana/Vincennes": "us",
  "America/Indiana/Winamac": "us",
  "America/Inuvik": "ca",
  "America/Iqaluit": "ca",
  "America/Juneau": "us",
  "America/Kentucky/Louisville": "us",
  "America/Kentucky/Monticello": "us",
  "America/Lima": "pe",
  "America/Los_Angeles": "us",
  "America/Maceio": "br",
  "America/Manaus": "br",
  "America/Matamoros": "mx",
  "America/Mazatlan": "mx",
  "America/Menominee": "us",
  "America/Merida": "mx",
  "America/Metlakatla": "us",
  "America/Mexico_City": "mx",
  "America/Moncton": "ca",
  "America/Monterrey": "mx",
  "America/New_York": "us",
  "America/Nome": "us",
  "America/Noronha": "br",
  "America/North_Dakota/Beulah": "us",
  "America/North_Dakota/Center": "us",
  "America/North_Dakota/New_Salem": "us",
  "America/Ojinaga": "mx",
  "America/Phoenix": "us",
  "America/Porto_Velho": "br",
  "America/Punta_Arenas": "cl",
  "America/Rankin_Inlet": "ca",
  "America/Recife": "br",
  "America/Regina": "ca",
  "America/Resolute": "ca",
  "America/Rio_Branco": "br",
  "America/Santarem": "br",
  "America/Santiago": "cl",
  "America/Sao_Paulo": "br",
  "America/Sitka": "us",
  "America/St_Johns": "ca",
  "America/St_Thomas": "vi",
  "America/Swift_Current": "ca",
  "America/Tijuana": "mx",
  "America/Toronto": "ca",
  "America/Vancouver": "ca",
  "America/Whitehorse": "ca",
  "America/Winnipeg": "ca",
  "America/Yakutat": "us",
  "Antarctica/Macquarie": "au",
  "Asia/Almaty": "kz",
  "Asia/Anadyr": "ru",
  "Asia/Aqtau": "kz",
  "Asia/Aqtobe": "kz",
  "Asia/Atyrau": "kz",
  "Asia/Bangkok": "th",
  "Asia/Barnaul": "ru",
  "Asia/Chita": "ru",
  "Asia/Dubai": "ae",
  "Asia/Hong_Kong": "hk",
  "Asia/Irkutsk": "ru",
  "Asia/Jakarta": "id",
  "Asia/Jayapura": "id",
  "Asia/Kamchatka": "ru",
  "Asia/Khandyga": "ru",
  "Asia/Kolkata": "in",
  "Asia/Krasnoyarsk": "ru",
  "Asia/Kuala_Lumpur": "my",
  "Asia/Kuching": "my",
  "Asia/Magadan": "ru",
  "Asia/Makassar": "id",
  "Asia/Manila": "ph",
  "Asia/Novokuznetsk": "ru",
  "Asia/Novosibirsk": "ru",
  "Asia/Omsk": "ru",
  "Asia/Oral": "kz",
  "Asia/Pontianak": "id",
  "Asia/Qostanay": "kz",
  "Asia/Qyzylorda": "kz",
  "Asia/Riyadh": "sa",
  "Asia/Sakhalin": "ru",
  "Asia/Seoul": "kr",
  "Asia/Singapore": "sg",
  "Asia/Srednekolymsk": "ru",
  "Asia/Tbilisi": "ge",
  "Asia/Tokyo": "jp",
  "Asia/Tomsk": "ru",
  "Asia/Ust-Nera": "ru",
  "Asia/Vladivostok": "ru",
  "Asia/Yakutsk": "ru",
  "Asia/Yekaterinburg": "ru",
  "Atlantic/Azores": "pt",
  "Atlantic/Canary": "es",
  "Atlantic/Madeira": "pt",
  "Atlantic/Reykjavik": "is",
  "Australia/Adelaide": "au",
  "Australia/Brisbane": "au",
  "Australia/Broken_Hill": "au",
  "Australia/Darwin": "au",
  "Australia/Eucla": "au",
  "Australia/Hobart": "au",
  "Australia/Lindeman": "au",
  "Australia/Lord_Howe": "au",
  "Australia/Melbourne": "au",
  "Australia/Perth": "au",
  "Australia/Sydney": "au",
  "Europe/Amsterdam": "nl",
  "Europe/Astrakhan": "ru",
  "Europe/Berlin": "de",
  "Europe/Bratislava": "sk",
  "Europe/Bucharest": "ro",
  "Europe/Budapest": "hu",
  "Europe/Busingen": "de",
  "Europe/Copenhagen": "dk",
  "Europe/Dublin": "ie",
  "Europe/Guernsey": "gg",
  "Europe/Helsinki": "fi",
  "Europe/Isle_of_Man": "im",
  "Europe/Istanbul": "tr",
  "Europe/Jersey": "je",
  "Europe/Kaliningrad": "ru",
  "Europe/Kirov": "ru",
  "Europe/Kyiv": "ua",
  "Europe/Lisbon": "pt",
  "Europe/Ljubljana": "si",
  "Europe/London": "gb",
  "Europe/Luxembourg": "lu",
  "Europe/Madrid": "es",
  "Europe/Moscow": "ru",
  "Europe/Oslo": "no",
  "Europe/Paris": "fr",
  "Europe/Prague": "cz",
  "Europe/Riga": "lv",
  "Europe/Rome": "it",
  "Europe/Samara": "ru",
  "Europe/Saratov": "ru",
  "Europe/Simferopol": "ru",
  "Europe/Stockholm": "se",
  "Europe/Tallinn": "ee",
  "Europe/Ulyanovsk": "ru",
  "Europe/Vaduz": "li",
  "Europe/Vienna": "at",
  "Europe/Vilnius": "lt",
  "Europe/Volgograd": "ru",
  "Europe/Warsaw": "pl",
  "Europe/Zagreb": "hr",
  "Europe/Zurich": "ch",
  "Pacific/Auckland": "nz",
  "Pacific/Chatham": "nz",
  "Pacific/Easter": "cl",
  "Pacific/Honolulu": "us",
};
